import React from "react";

function DashboardHeader() {
  return (
    <div className="px-2 pt-2 w-full">
      <div className="h-16 flex justify-between align-center">
        <div className="flex flex-row align-center">
          <img className="h-12 rounded-full" src="/pic.jpeg" alt="" />
          <div className="pt-3 pl-4 text-base font-bold">Hello, Abhishek!</div>
        </div>
        <div className="pt-1 flex flex-row">
          <div>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="20" cy="20" r="20" fill="#C6007E" />
              <path
                d="M13.7143 13.2812C13.3411 13.2812 13.0357 13.5766 13.0357 13.9375V27.0625C13.0357 27.4234 13.3411 27.7188 13.7143 27.7188H23.2143V24.4375C23.2143 23.7115 23.8208 23.125 24.5714 23.125H27.9643V13.9375C27.9643 13.5766 27.6589 13.2812 27.2857 13.2812H13.7143ZM23.2143 29.6875H13.7143C12.2172 29.6875 11 28.5104 11 27.0625V13.9375C11 12.4896 12.2172 11.3125 13.7143 11.3125H27.2857C28.7828 11.3125 30 12.4896 30 13.9375V23.125V23.3506C30 24.0479 29.7158 24.7164 29.2069 25.2086L25.3687 28.9205C24.8598 29.4127 24.1685 29.6875 23.4475 29.6875H23.2143Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="ml-2">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="20" cy="20" r="20" fill="#C6007E" />
              <g clip-path="url(#clip0_9_592)">
                <path
                  d="M18.7629 12.1815L19.5714 12.0237V11.2V10.375C19.5714 10.2024 19.7257 10 20 10C20.2742 10 20.4286 10.2024 20.4286 10.375V11.2V12.0237L21.237 12.1815C24.0616 12.7327 26.1428 15.1252 26.1428 17.9375V18.7453C26.1428 21.0264 27.0138 23.2131 28.5724 24.9055L28.5744 24.9077L28.9048 25.2643L28.9055 25.2652C29.0081 25.3756 29.0255 25.5194 28.9699 25.6377C28.9081 25.7692 28.7595 25.875 28.5714 25.875H11.4286C11.2354 25.875 11.089 25.7654 11.0332 25.6444C10.9743 25.5165 10.9965 25.3707 11.0944 25.2652L11.0952 25.2643L11.4256 24.9077L11.4276 24.9055C12.9863 23.2129 13.8571 21.0218 13.8571 18.7453V17.9375C13.8571 15.1252 15.9384 12.7327 18.7629 12.1815ZM21.5269 29.25C21.4682 29.3298 21.4021 29.4055 21.3288 29.476C20.9849 29.807 20.508 30 20 30C19.4919 30 19.015 29.807 18.6711 29.476C18.5978 29.4055 18.5317 29.3298 18.4731 29.25H20H21.5269Z"
                  stroke="white"
                  stroke-width="2"
                />
              </g>
              <defs>
                <clipPath id="clip0_9_592">
                  <rect
                    width="20"
                    height="22"
                    fill="white"
                    transform="translate(10 9)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHeader;
